import {resourceEnumerate} from '@aofl/resource-enumerate';

/**
 *
 */
class ServerTime {
  /**
   *
   * @param {String} apiNs
   */
  constructor(apiNs) {
    this.delta = 0;
    this._setTimeDelta(apiNs);
  }
  /**
   * @param {String} apiNs
   */
  _setTimeDelta(apiNs) {
    if (typeof apiNs === 'undefined') {
      throw new Error('api namespace is required');
    }

    let preCall = Math.round(Date.now() / 1000);
    resourceEnumerate.get(apiNs, true).then(data => {
      let postCall = Math.round(Date.now() / 1000);
      let apiTimestamp = data.payload.reference_timestamp;

      this.delta = apiTimestamp - Math.round((preCall + postCall) / 2);
    });
  }

  /**
   * @return {Number}
   */
  getDelta() {
    return this.delta;
  }

  /**
   *
   * @return {Number}
   */
  getAdjustedTime() {
    let timestamp = Math.round(Date.now() / 1000);
    return timestamp + this.delta;
  }
}

export default ServerTime;



// WEBPACK FOOTER //
// ./server-time/src/ServerTime/index.js